(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PeopleFranchiserListController', PeopleFranchiserListController)

    /** @ngInject */
    function PeopleFranchiserListController($timeout, $q, UnitService, AccessLevelService, ResponsabilityService, PersonService, AuthenticationService, HelperService, SYSTEM_MODULES) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;
        let allUnits = [];

        vm.isSearchDisabled = () => {
            if (vm.selectedAccessLevel || vm.selectedResponsability || vm.selectedUnit || (vm.selectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedAccessLevel || vm.selectedResponsability || vm.selectedUnit || vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                vm.isFirstCall = false;
                vm.isLoading = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedUnit = null;
            vm.selectedAccessLevel = null;
            vm.selectedResponsability = null;
            vm.selectedSearchField = null;
            vm.searchText = null;
            vm.people = [];
            vm.isFirstCall = true;

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            if (vm.isFirstCall) {
                vm.isLoading = false;
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getPeople(start, number, tableState);
        }

        vm.getUnits = search => {
            if (!search) {
                vm.units = [];
                return;
            }

            vm.units = allUnits.filter(unit => filterUnit(unit, search))
        }

        vm.orderPersonResponsibilities = personUnits => {
            let filteredPersonUnits = [];

            for (let index = 0; index < personUnits.length; index++) {
                const personUnit = personUnits[index];
                let foundFPU = filteredPersonUnits.find(fpu => (fpu.ResponsibilityId == personUnit.ResponsibilityId));

                if (foundFPU) {
                    foundFPU.Units.push(personUnit.Unit)
                } else {
                    filteredPersonUnits.push({
                        ResponsibilityId: personUnit.ResponsibilityId,
                        Responsibility: personUnit.Responsibility,
                        Units: [personUnit.Unit]
                    })
                }
            }

            return filteredPersonUnits;
        }

        init();

        function getPeople(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            PersonService
                .getByParameters(parameters)
                .then(success => {
                    vm.people = success.People;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.people = null;
                    vm.isLoading = false;
                    HelperService.errorCallback(error);
                })
        }

        function getAccessLevels() {
            AccessLevelService
                .getAll()
                .then(success => {
                    vm.accessLevels = success;
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.custom-filters');
                })
        }

        function getResponsabilities() {
            return ResponsabilityService
                .getAll()
                .then(success => {
                    vm.responsabilities = success;
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.custom-filters');
                })
        }

        function getAllUnitsResumed() {
            return UnitService
                .getAllResumed()
                .then(success => {
                    allUnits = success;
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.custom-filters');
                })
        }

        function filterUnit(unit, search) {
            if (unit.FantasyName == null)
                unit.FantasyName = '';

            if (unit.CorporateName == null)
                unit.CorporateName = '';

            if (unit.UniqueCode == null)
                unit.UniqueCode = '';

            if (unit.ExternalCode == null)
                unit.ExternalCode = '';

            if (unit.FantasyName.toLowerCase().includes(search.toLowerCase()) || unit.CorporateName.toLowerCase().includes(search.toLowerCase()) || unit.UniqueCode.toString().includes(search) || unit.ExternalCode.toString().includes(search))
                return unit;
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Name',
                OrderDescending: false
            }

            if (vm.selectedAccessLevel || vm.selectedResponsability || vm.selectedUnit || (vm.selectedSearchField && vm.searchText))
                isTableSearch = true;

            if (vm.selectedAccessLevel)
                params.AccessLevelId = vm.selectedAccessLevel.Id;

            if (vm.selectedResponsability)
                params.ResponsabilityId = vm.selectedResponsability.Id;

            if (vm.selectedUnit)
                params.UnitId = vm.selectedUnit.Id;

            if (tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function init() {
            const loggedUserData = AuthenticationService.getSelectedData();

            vm.canUserHandlePerson = AuthenticationService.getUnitDataByAccessLevelAndModuleId(loggedUserData.AccessLevelId, SYSTEM_MODULES.FRANCHISER_PEOPLE).length > 0;
            vm.selectedUnit;
            vm.selectedResponsability;
            vm.selectedAccessLevel;
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = false;
            vm.isFirstCall = true;

            vm.searchFields = [{
                Value: 'Document',
                Description: 'Documento'
            }, {
                Value: 'Name',
                Description: 'Nome'
            }, {
                Value: 'Email',
                Description: 'E-mail'
            }];

            HelperService.startLoading('.custom-filters');

            $q.all([getAccessLevels(), getResponsabilities(), getAllUnitsResumed()])
                .then(() => {
                    HelperService.stopLoading('.custom-filters');
                })
        }
    }
}());